import { render, staticRenderFns } from "./VisualizarResponsaveis.vue?vue&type=template&id=8a7954f2&"
import script from "./VisualizarResponsaveis.vue?vue&type=script&lang=js&"
export * from "./VisualizarResponsaveis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports